export const meta = () => {
	return [{ title: 'Membership | EBHS' }]
}

export default function Membership() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Membership
					</h2>
				</div>
			</header>
			<div className="pt-4 pb-8">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<p className="p-3">
						We thank everyone who is currently a member of the East Bloomfield
						Historical Society, your membership directly supports our programs,
						exhibits and student activities.
					</p>
					<p className="p-3">
						If you are a current member, do you have a friend who is NOT a
						member of the Historical Society? Why not be a really good friend
						and ask them to join?
					</p>

					<ul className="mt-8 rounded-md border border-gray-200 bg-white">
						<li className="flex items-center justify-between py-3 pl-3 pr-4 text-xl leading-5">
							<div className="flex w-0 flex-1 items-center">
								<span className="ml-2 w-0 flex-1 truncate">
									<a
										href="https://ebhs1838.s3.amazonaws.com/Membership%20Form.pdf"
										className="font-medium leading-normal text-blue-700 transition duration-150 ease-in-out hover:text-blue-500"
										target="_blank"
										rel="noopener noreferrer"
									>
										Become a Member
									</a>
								</span>
							</div>
						</li>
					</ul>
					<form
						action="https://www.paypal.com/donate"
						method="post"
						className="p-3"
						target="_blank"
					>
						To complete your membership payment online you can submit your
						payment here:{' '}
						<input
							type="hidden"
							name="hosted_button_id"
							value="77YWK8A2WPZ8N"
						/>
						<button
							type="submit"
							className="inline-flex items-center rounded-full border border-transparent bg-ebhs-blue px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-ebhs-blue-light focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
						>
							Donate
						</button>
					</form>
				</div>
			</div>
		</>
	)
}
